/**
 * @generated SignedSource<<7139775b8c82381d31ad031e33830912>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PublishReportInput = {
  reportId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type PublishReportMutation$variables = {
  input: PublishReportInput;
};
export type PublishReportMutation$data = {
  readonly publishReport: {
    readonly draftState: string | null;
    readonly publishedAt: string | null;
    readonly locked: boolean | null;
    readonly draftFilterWillRevert: boolean | null;
  } | null;
};
export type PublishReportMutation = {
  variables: PublishReportMutation$variables;
  response: PublishReportMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublishReportPayload",
    "kind": "LinkedField",
    "name": "publishReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftFilterWillRevert",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublishReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63e65f0cc1c234971a54d4eea9c6a36b",
    "id": null,
    "metadata": {},
    "name": "PublishReportMutation",
    "operationKind": "mutation",
    "text": "mutation PublishReportMutation(\n  $input: PublishReportInput!\n) {\n  publishReport(input: $input) {\n    draftState\n    publishedAt\n    locked\n    draftFilterWillRevert\n  }\n}\n"
  }
};
})();

(node as any).hash = "8651bffcab2f860de5bcd96191a0db4d";

export default node;
